import * as Sentry from "@sentry/react";
import { useUserProfile } from "@src/components/user/user-context";
import { usePostHog } from "posthog-js/react";
import { useEffect } from "react";

export function usePosthogIdentification() {
	const posthog = usePostHog();
	const {
		user: [user],
	} = useUserProfile();

	useEffect(() => {
		if (!user) return;

		Sentry.setUser({
			id: user.id,
			email: user.email,
			username: user.displayName,
		});

		// Use the app's stable user ID as the PostHog distinct ID so anonymous
		// pre-login activity can be merged into the authenticated person profile.
		posthog.identify(user.email, {
			userId: user.id,
			email: user.email,
			name: user.displayName,
			displayName: user.displayName,
			firstName: user.firstName,
			lastName: user.lastName,
			avatarUrl: user.avatarUrl,
		});
	}, [user, posthog]);
}
